import { createFetchedData, LoadingState } from '@vista-digital/utilities';
export const defaultSalesDataDomainState = {
    ticketPricesByShowtimeId: {},
    ticketTypesById: {},
    itemProfilesBySiteId: {},
    itemProfileForGiftShop: createFetchedData(LoadingState.NotLoaded),
    itemAvailabilitiesBySiteId: {},
    itemAvailabilitiesByItemId: {},
    itemAvailabilitiesForGiftShop: createFetchedData(LoadingState.NotLoaded),
    discountAvailabilitiesByDiscountId: createFetchedData(LoadingState.NotLoaded),
    discountsById: {},
    sellableItemsForSiteByHopk: {},
    itemsById: {},
    itemModifierGroupsById: {},
    subscriptionBillingOptionsById: createFetchedData(LoadingState.NotLoaded),
    availableHoursById: {}
};
//# sourceMappingURL=state.js.map